import { Message } from "element-ui";
export default { dealResult };
//对后端返回结果进行处理，根据res.code输出对应的消息
function dealResult(res){
    if(res.code == 0){
        Message({
            message:res.msg,
            offset: 100,
            type:"success"
        })
    }else{
        Message({
            message:res.msg,
            offset: 100,
            type:"error"
        })
    }
}


// WEBPACK FOOTER //
// ./src/common/js/common.js